module.exports = __webpack_public_path__ + "static/media/warranty.51e9cc54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/features/warranty.png
// module id = 1627
// module chunks = 0